<div class="w-full h-full flex flex-col justify-between">
    <div class="lista-rolavel flex-1 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-200">
        <!-- O X de fechar existe só no mobile; no desktop quem recolhe o menu é o
             botão "Menu" do header. -->
        <div class="flex justify-end px-4 pt-3 md:hidden">
            <button matIconButton type="button" aria-label="Fechar menu" (click)="interactMenu()">
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <!-- Some quando não há nenhum favorito: uma seção vazia com título só ocupa
             espaço e ensina o usuário a ignorar aquele canto do menu. -->
        @if (favoritos().length) {
            <mat-nav-list class="overflow-x-hidden px-4 favoritos">
                <p class="titulo-secao">Favoritos</p>

                @for (item of favoritos(); track item.title) {
                <app-item-menu (close)="interactMenu()" (itemClick)="onItemClick($event)" [itemMenu]="item"
                    [title]="item.title">
                </app-item-menu>
                }
            </mat-nav-list>
        }

        <mat-nav-list class="overflow-x-hidden px-4">
            @for (item of menuItems; track $index) {
            <app-item-menu (close)="interactMenu()" (itemClick)="onItemClick($event)" [itemMenu]="item"
                [title]="item.title">
            </app-item-menu>
            }
        </mat-nav-list>

        <div class="w-full space-y-3 z-20 h-10 sticky bottom-0 bg-gradient-to-t from-white to-[#ffffff00]"></div>
    </div>

    <div class="infos-passo sticky bottom-0 px-4">
        <div class="w-full flex flex-col bg-[#F2F2F2] border border-[#e9e9e9] gap-2 rounded-xl z-30">
            <div class="flex flex-col gap-2 p-4">
                <div class="flex flex-row gap-2">
                    <div class="flex flex-row gap-2 items-center rounded-lg">
                        <img class="w-9 h-9 border-2 rounded-full" [src]="userService.picture" alt="User image">
                    </div>

                    <div class="grow flex flex-col justify-center">
                        @if (!userStore.user().name && !(userService.searchedCnpj | formatCnpj)) {
                        <span (click)="cnpjService.showCnpjPopup(true)"
                            class="text-gray-500 text-xs font-medium antialiased">
                            Nenhum CNPJ selecionado.
                            <br>
                            <span class="underline text-hs-active cursor-pointer">
                                Clique para selecionar
                            </span>
                        </span>
                        } @else {
                        <div class="flex flex-col gap-1">
                            <p class="text-xs font-bold text-[#373737]">
                                {{ userStore.user().selectedCnpj | formatCnpj }}
                            </p>
                            <p class="text-xs font-medium text-[#373737]">
                                {{ userStore.user().selectedCnpjName || '' }}
                            </p>
                            <p (click)="cnpjService.showCnpjPopup(true)" class="text-hs-active underline">
                                Trocar CNPJ
                            </p>
                        </div>
                        }
                    </div>

                    <div class="flex items-center justify-center">
                        <button matIconButton type="button" (click)="closeUserMenu()"
                            [attr.aria-expanded]="userMenu()" aria-label="Detalhes da conta">
                            <mat-icon [@rotateArrow]="userMenu() ? 'expanded' : 'collapsed'">expand_less</mat-icon>
                        </button>
                    </div>
                </div>
            </div>

            @if (userMenu()) {
            <div class="flex gap-2 flex-col bg-white p-4 rounded-t-xl rounded-b-xl">
                <p class="text-xs text-[#373737]">
                    Plano:
                    <span class="font-bold text-hs-gray">{{ userStore.user().plan }}</span>
                </p>

                <p class="text-xs text-[#696969] font-normal">
                    O CNPJ selecionado será utilizado para filtrar as informações do Otimiza de acordo com ele.
                </p>

                @if (isFreemium) {
                <app-button buttonSize="medium" [isLoading]="isLoadingBeLicensed()"
                    [isDisabled]="isLoadingBeLicensed()" (buttonClick)="applyForLicense()">
                    <mat-icon>verified</mat-icon>
                    Quero ser licenciado
                </app-button>
                }
            </div>

            }
        </div>
    </div>

    <mat-nav-list class="px-4">
        <a mat-list-item (click)="logout()">
            <!-- SVG pelo mesmo motivo da seta em item-menu: ligadura de fonte de ícone
                 quebra dentro da linha da lista e o nome aparece escrito. -->
            <span matListItemIcon>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                </svg>
            </span>
            <span matListItemTitle>Sair</span>
        </a>
    </mat-nav-list>

    <p class="versao px-4 pb-3 text-left text-xs text-gray-400">versão {{ appVersion }}</p>
</div>